module.exports = __webpack_public_path__ + "img/img-flower-landing-web.c0444ec8.svg";